var _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPrivacyLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 198,
    height: 63,
    viewBox: "0 0 198 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2259 37.8113C23.8343 37.8113 26.8613 33.0173 26.8613 25.6232V13.5164C26.8613 6.12232 24.8979 1.5721 15.6532 1.5721H0.190918V62.0249H11.0718V37.8113H16.2259ZM11.0718 10.9163H13.1171C15.5714 10.9163 15.8987 12.3789 15.8987 14.4915V24.5669C15.8987 26.4358 15.5714 27.9796 13.1171 27.9796H11.0718V10.9163Z",
    fill: "#6C37CE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7672 10.9163H45.2216C47.4305 10.9163 47.9213 11.7288 47.9213 14.329V22.5356C47.9213 25.3795 47.0214 26.192 44.8943 26.192H42.7672V10.9163ZM42.7672 36.1862H45.0579C47.2668 36.1862 47.9213 36.9988 47.9213 39.7614V57.3935C47.9213 60.0748 48.4122 61.3749 48.903 62.0249H59.7839V61.6187C59.3749 60.8874 58.884 59.7498 58.884 57.1497V36.5925C58.884 32.0423 56.0206 30.0922 54.2208 29.4422C56.266 28.6296 59.0476 26.192 59.0476 21.3168V11.6476C59.0476 5.22852 55.6934 1.5721 49.0667 1.5721H31.8863V62.0249H42.7672V36.1862Z",
    fill: "#6C37CE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1018 1.5721H64.2209V62.0249H75.1018V1.5721Z",
    fill: "#6C37CE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9561 62.0249H100.782L108.554 1.5721H98.1642L94.1555 42.1177L90.1467 1.5721H78.8568L86.9561 62.0249Z",
    fill: "#6C37CE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M126.319 62.0249H136.873L128.61 1.5721H115.684L107.994 62.0249H117.647L118.629 51.8682H125.174L126.319 62.0249ZM121.82 20.748L124.11 41.4677H119.693L121.82 20.748Z",
    fill: "#6C37CE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M156.82 48.6993C156.82 50.8932 156.084 52.3557 154.12 52.3557C152.157 52.3557 151.339 51.0557 151.339 48.6993V14.5727C151.339 12.2164 151.993 11.0788 154.039 11.0788C156.084 11.0788 156.82 12.2976 156.82 14.5727V24.3232H167.619V14.1664C167.619 7.25987 165.41 0.84082 155.02 0.84082H152.811C143.158 0.84082 139.967 7.25987 139.967 14.5727V48.6993C139.967 56.2559 142.34 63 152.811 63H155.02C164.674 63 167.619 56.2559 167.619 49.0243V35.3737H156.82V48.6993Z",
    fill: "#6C37CE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M198 1.5721H188.183L184.501 23.0231L180.82 1.5721H169.939L178.938 38.6238V62.0249H189.819V38.2176L198 1.5721Z",
    fill: "#6C37CE"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacyLogo);
export default __webpack_public_path__ + "static/media/privacy-logo.a489908090259f04ebdcd89191808093.svg";
export { ForwardRef as ReactComponent };